import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig } from '@/types'
import { CopyFunction } from '@/types/partnerConfig'

const { FOOTERLINKS, LOGOS, USA } = DEFAULT
const { WELCOME, REGISTRATION, SUMMARY } = USA.CONTENT

const partnerName = 'Babylon'
const planName = 'your health plan'

const babylonUs: PartnerConfig = {
  branding: {
    logo: [LOGOS.BABYLON],
  },
  config: {
    ...USA.CONFIG,
    id: 'babylon-health',
    name: partnerName,
    codes: {
      membership: 'babylonuswebreg',
    },
    partnerUrlSlug: 'us',
  },
  content: {
    'en-US': {
      steps: [
        {
          ...WELCOME.enUS,
          copy: (WELCOME.enUS.copy as CopyFunction)(planName),
        },
        REGISTRATION.enUS,
        SUMMARY.enUS,
      ],
      footerLinks: FOOTERLINKS.USA,
    },
    'es-US': {
      steps: [
        {
          ...WELCOME.esUS,
          copy: (WELCOME.esUS.copy as CopyFunction)(planName),
        },
        REGISTRATION.esUS,
        SUMMARY.esUS,
      ],
      footerLinks: FOOTERLINKS.USA,
    },
  },
}

const babylonUsWithDnaV2Design: PartnerConfig = {
  ...babylonUs,
  config: {
    ...babylonUs.config,
    useDnaV2Design: true,
  },
}

export default [babylonUs, babylonUsWithDnaV2Design]
